import React from 'react';
import {
  Column,
  BadgeCell,
  BadgeCellComponentProps,
} from '@odin-labs/components';
import { Breakdown } from './types';

export const columns: Column<Breakdown>[] = [
  {
    id: 'name',
    Header: 'Jobsite',
    accessor: 'name',
    Cell: ({ value }: { value: string }) => (
      <span
        className="
          odin-inline-block
          odin-truncate
          md:odin-max-w-[22rem] 
          lg:odin-max-w-[12rem] 
          xl:odin-max-w-[6rem] 
          2xl:odin-max-w-[12rem]
        "
        title={value}
      >
        {value}
      </span>
    ),
  },
  {
    id: 'count',
    Header: 'Count',
    Cell: BadgeCell,
    componentProps: ({ count }: Breakdown): BadgeCellComponentProps => ({
      text: count?.toString(),
    }),
  },
  {
    id: 'percentage',
    Header: 'Percentage',
    accessor: (breakdown): string => `${Math.round(breakdown.percentage)}%`,
  },
];
